const { createBoolean, createObject, createString, traversePropertiesArray,traversePropertiesString, valueIf} = require('../../shared');

module.exports.dependents = function (appData, formData, outData){

  if (!outData.error && !createObject(appData, "dependents", [])) {
    outData.error = "Cannot create dependent info";
  }

  const dependentData = traversePropertiesArray(formData,['dependents']);

  dependentData.some((dependentFormData, index) => {

    const tempDependent = {};

    if (!outData.error && !createString(tempDependent, "firstName", traversePropertiesString(dependentFormData,['fname']), true)) {
      outData.error = "Cannot set dependent " + (index + 1) + " First Name";
    }

    if (!outData.error && !createString(tempDependent, "mi", traversePropertiesString(dependentFormData,['middleInitial']))) {
      outData.error = "Cannot set dependent " + (index + 1) + " Middle Initial";
    }

    if (!outData.error && !createString(tempDependent, "lastName", traversePropertiesString(dependentFormData,['lname']), true)) {
      outData.error = "Cannot set dependent " + (index + 1) + " Last Name";
    }

    if (!outData.error && !createString(tempDependent, "gender", traversePropertiesString(dependentFormData,['gender']), true)) {
      outData.error = "Cannot set dependent " + (index + 1) + " Gender";
    }

    if (!outData.error && !createString(tempDependent, "dob", traversePropertiesString(dependentFormData,['bdate']), true)) {
      outData.error = "Cannot set dependent " + (index + 1) + " Birhdate";
    }

    if (outData.error) {
      return true;
    } else {
      appData.dependents.push(tempDependent);
    }

  });

}


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/MBA/dependents.js